import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/dotacoes'

class SetupDotacaoOrcamentariaPedidoApiClient {
	async buscarListagemExercicios() {
		return await axios.get(`${URL_PATH}/anos-exercicios`)
	}
	async buscarListagemClassificacaoDespesas(idPedido) {
		return await axios.get(`api/pedido/elemento-subelemento/${idPedido}`)
	}
	async buscarListagemOrgaos(idPedido) {
		return await axios.get(`api/pedido/${idPedido}/dotacoes/orgao`)
	}
	async buscarListagemPaginada(idPedido, filters, pagingAndSorting) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/pedido/${idPedido}`,
			filters,
			pagingAndSorting,
		}).build()
		return await axios.get(url)
	}
}

export default new SetupDotacaoOrcamentariaPedidoApiClient()
